import alert from "@mixins/alert.js"
import modal from "@mixins/modal.js"
import apitools from "@mixins/apitools.js"

export default {
  name: "list",
  mixins: [alert, modal, apitools],
  data() {
    return {
      moduleName: "",
      title: "",
      loading: true,
      updateMode: false,
      item: null,
      isSaveAndBack: false,
      isSaveAndAdd: false
    }
  },
  watch: {
    loading(val) {
      this.$loading = this.loading
    }
  },
  beforeMount() {
    this.$validate = true
    this.resetHeaderTitle()
  },
  mounted() {
    this.beforeMountedState()
    this.setUpdateMode()
    this.get()
    this.mountedState()
  },
  beforeDestroy() {
    this.resetHeaderTitle()
  },
  methods: {
    beforeMountedState() { },
    clone(item) {
      return JSON.parse(JSON.stringify(item))
    },
    getRes(it) {
      return it.resources.find(res => res.languageId == this.tabs.languageIdActive)
    },
    getResWithLangId(it, languageId) {
      return it.resources.find(res => res.languageId == languageId)
    },
    getLanguageName(id) {
      return this.getLanguageFromId(id).name
    },
    getLanguageFromId(id) {
      return this.$languages.find(lang => lang.id === id)
    },
    setTitleParameter(item) {
      this.$headerTitle = this.updateMode
        ? this.$parseEsTemplate.parse(
          this.$t(`${this.moduleName}.header.edit`),
          this
        )
        : this.$parseEsTemplate.parse(
          this.$t(`${this.moduleName}.header.get`),
          this
        )
    },
    resetHeaderTitle() {
      this.$headerTitle = null
    },
    setUpdateMode() {
      if (
        this.$route.params !== undefined &&
        this.$route.params.id !== undefined
      ) {
        this.updateMode = true
      }

      if (this.$route.params !== undefined && this.$route.params.created) {
        this.newItemMessage()
      }
    },
    beforeCreate() {
      //override me in module
      this.$validate = false
      this.$isModified = false
    },
    create() {
      this.loading = true
      this.beforeCreate()

      axios
        .post(`/api/${this.moduleName}/create/`, this.item)
        .then(response => {
          this.getAndSetBadgeCountForModule(this.moduleName)
          this.$isModified = false

          this.updated()
          this.loading = false
          this.created()

          if (this.isSaveAndBack) {
            this.goToList()
            return
          }

          if (this.isSaveAndAdd) {
            this.goToAdd()
            return
          }

          this.$router.push({
            name: `edit${this.moduleName}`,
            params: {
              id: response.data.data.id,
              created: response.data.data
            }
          })
        })
        .catch(error => {
          this.alert.success = false
          this.alert.message = this.manageErrorMessage(
            error.response.data.error
          )
          this.loading = false
        })
    },
    created() {
      //override me in module
      this.$validate = true
    },
    beforeUpdate() {
      //override me in module
      this.$isModified = false
    },
    goToList() {
      this.$router.push({ name: `${this.moduleName}` })
    },
    goToAdd() {
      this.$router.push({
        name: `${this.moduleName}`,
        query: {
          reset: true
        }
      })
    },
    update() {
      this.loading = true
      this.badgeUpdating(this.moduleName)

      this.beforeUpdate()

      axios
        .put(`/api/${this.moduleName}/update/`, this.item)
        .then(response => {
          this.getAndSetBadgeCountForModule(this.moduleName)
          this.$isModified = false

          this.updated()
          this.loading = false

          this.item = response.data.data
          this.updated()
          this.loading = false
          this.setTitleParameter(this.item)

          if (this.isSaveAndBack) {
            this.goToList()
            return
          }

          if (this.isSaveAndAdd) {
            this.goToAdd()
            return
          }

          this.alert.success = true
          this.alert.message = this.$parseEsTemplate.parse(
            this.$t(`${this.moduleName}.itemModifiedMessage`),
            this
          )
        })
        .catch(error => {
          this.alert.success = false
          this.alert.message = this.manageErrorMessage(
            error.response.data.error
          )
          this.loading = false
        })
    },
    mountedState() {
      //to override in module, called after all function in mounted
    },
    updated() {
      //override me in module
    },
    beforeGet() {
      //override me in module
    },
    get() {
      this.beforeGet()

      var url = this.updateMode
        ? `/api/${this.moduleName}/get/${this.$route.params.id}`
        : `/api/${this.moduleName}/get/`

      axios
        .get(url)
        .then(response => {
          this.item = response.data.data
          this.setTitleParameter(this.item)

          this.got()
          this.loading = false
        })
        .catch(error => {
          console.log("---------------------------")
          console.log(error)
          this.$router.push({
            name: `list${this.moduleName}`,
            params: {
              error: error.response.data.error.code
            }
          })
        })
    },
    got() {
      //override me in module
    },
    newItemMessage() {
      this.item = this.$route.params.created
      this.alert.success = true
      this.alert.message = this.$parseEsTemplate.parse(
        this.$t(`${this.moduleName}.itemAddedMessage`),
        this
      )
    },
    deleteModal() {
      this.modalInfo.item = this.item
      this.modalInfo.msg = this.$parseEsTemplate.parse(
        this.$t(`${this.moduleName}.itemModalDeleteConfirmMessage`),
        this
      )
      this.modalInfo.popup = true
    },
    deleteItem(item) {
      axios
        .delete(`/api/${this.moduleName}/delete/${item.id}`)
        .then(response => {
          this.getAndSetBadgeCountForModule(this.moduleName)
          this.$isModified = false

          this.$router.push({
            name: `list${this.moduleName}`,
            params: {
              deleted: this.item
            }
          })
        })
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/get.js
// module id = 9+Yz
// module chunks = 18